export function updateLocaleInUrl(url, newLocale, currency) {
  try {
    const urlObj = new URL(url)
    urlObj.searchParams.set('locale', newLocale)
    urlObj.searchParams.set('hide_tagline', 'true')
    urlObj.searchParams.set('currency', currency)
    urlObj.searchParams.set('has_shadow', 'true')
    return urlObj.toString()
  } catch {
    return url
  }
}

export function standardizeLocale(locale) {
  const convertLocales = {
    en: 'en-GB',
    fr: 'fr',
    de: 'de',
    es: 'es',
    zh_CN: 'zh'
  }
  return convertLocales[locale] || locale
}

export const getWidgetDimensions = (width) => {
  if (width >= 375 && width < 440) return { width, height: 997 }
  if (width >= 440 && width < 950) return { width, height: 951 }
  if (width >= 950 && width < 1128) return { width, height: 621 }
  if (width >= 1128 && width < 1440) return { width, height: 647 }
  if (width >= 1440 && width < 1880) return { width, height: 697 }
  if (width >= 1880) return { width, height: 749 }
  // fallback
  return { width, height: 997 }
}